import { createContext } from 'react';

/**
 * Optional portal host for popup layers (Select / Combobox dropdowns, date
 * pickers, popovers).
 *
 * Two modal stacks make body portals unusable: Base UI dialogs treat other
 * `document.body` portals as outside content and block pointer events on them,
 * and Radix modal layers (vaul drawers — `MobileSheet`) set
 * `pointer-events: none` on the body itself, re-enabling it only inside their
 * own content subtree (UG-4755). Either way, a body-portaled popup opened from
 * inside the modal is unclickable. A modal surface that wants its popups
 * clickable provides its own subtree element here; app-local popup wrappers
 * (`FormSelect`, `SelectFilter`, `DateFilter`, comboboxes, sheet action
 * popovers) read it and portal into that element instead of the body. `null`
 * (the default) means "portal to document.body as usual". Dialogs provide the
 * host via `DialogPortalLayer` (UG-4769) instead of hand-rolling the recipe.
 */
export const OptionalPortalContainerContext = createContext<HTMLElement | null>(null);
